import React from 'react';

interface YouTubePlayerProps {
  videoUrl: string;
}

const YouTubePlayer: React.FC<YouTubePlayerProps> = ({ videoUrl }) => {
  const videoId = new URL(videoUrl).searchParams.get('v'); // Extract the video ID from the URL

  if (!videoId) {
    return null;
  }

  return (
    <iframe
      width='100%'
      height='100%'
      src={`https://www.youtube.com/embed/${videoId}`}
      title='YouTube video player'
      frameBorder='0'
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      allowFullScreen
    ></iframe>
  );
};

export default YouTubePlayer;
